import React from "react";

import styled, { keyframes } from "styled-components";
import cross from "../img/exit.png";
const appear = keyframes`
        from {
          margin-top: 20vh;
          opacity: 0;
        }
        to {
          margin-top: 0vh;
          opacity: 1;
        }
      `;
const appearPhone = keyframes`
        from {
          margin-top: 20vh;
          opacity: 0;
        }
        to {
          margin-top: -10vh;
          opacity: 1;
        }
      `;
const appear2 = keyframes`
      from {
        top: 14vh;
        opacity: 0;
      }
      to {
        top: 4;
        opacity: 1;
      }`;

const fade = keyframes`
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }`;
const Podklad = styled.div`
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.664);
  z-index: 6;
  display: flex;
  justify-content: center;
  align-items: center;
  animation-name: ${fade};
  animation-duration: 0.3s;
`;

const Krzyz = styled.img`
  cursor: pointer;
  height: 6vh;
  width: auto;
  position: fixed;
  top: 4vh;
  right: 8.5vw;
  z-index: 7;
  animation-name: ${appear2};
  animation-duration: 0.6s !important;
  transition: 0.3s;
  filter: drop-shadow(0 0 0.2vh #000000);
  &:hover {
    transform: scale(1.2);
  }
`;

const Kontent = styled.div`
  margin: none;
  width: 80vw;
  animation-name: ${appear};
  animation-duration: 0.6s;
  z-index: 2;
  @media screen and (max-width: 479px) {
    margin-top: -10vh;
    animation-name: ${appearPhone};
  }
`;

function Backdrop(props) {
  return (
    <Podklad>
      <Krzyz src={cross} onClick={props.jasno} />
      <Kontent>{props.kontent}</Kontent>
    </Podklad>
  );
}

export default Backdrop;
